



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ExportDialog from '@/components/Views/Dashboard/Import & Export/ExportDialog.vue';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import {DateTime} from 'luxon';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {multiNil, nil, orderStatusConfig} from '@/common';
import SingleAndMultiDashboardPage from '@/components/Views/Dashboard/SingleAndMultiDashboardPage.vue';
import OrderOverview from '@/components/Views/Dashboard/Orders/OrderOverview.vue';

@Component({
    components: {OrderOverview, PagedTable, ExportDialog},
})
export default class DashboardOrders extends Mixins(CurrencyMixin, SingleAndMultiDashboardPage) {
    public selectedOrders: any[] = [];
    private search = '';
    @Prop({default: () => (() => {})})
    public addToQuery!: () => any;

    @Prop({default: true})
    public showControls!: boolean;

    @Prop({default: 'Orders'})
    public title!: string;

    @Watch('search')
    public onSearchChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh();
    }
    public feathersModel = this.$FeathersVuex.Order;
    public routeParameter = 'order';
    public showingKey = false;
    private headers = [
        {
            text: 'Status',
            align: 'left',
            sortable: true,
            value: 'status',
        },
        {
            text: 'Stripe Payment Status',
            align: 'left',
            sortable: false,
            value: 'payment',
            func: (item: any) => nil(item.stripePaymentObject) ? '' : item.stripePaymentObject.status,
        },
        {
            text: 'Date Placed',
            align: 'left',
            sortable: true,
            value: 'createdAt',
            func: (item: any) => DateTime.fromISO(item.createdAt).toFormat('DDDD'),
        },
        {
            text: 'Customer',
            align: 'left',
            sortable: true,
            value: 'customer',
            html: (item: any) => {
                if (multiNil(item, 'purchaserModel')) { return '<b>Missing Customer Info</b>'; }
                const email = item.purchaserModel.email;
                const phone = item.purchaserModel.phone;
                return `<a href='mailto:${email}'>${email}</a><br/><a href='tel:${phone}'>${phone}</a>`;
            },
        },
        {
            text: 'Services Booked',
            align: 'left',
            sortable: false,
            value: 'bookings',
            func: (item: any) => item.bookings.length,
        },
        {
            text: 'Total Charge',
            align: 'left',
            sortable: false,
            value: 'charge',
            func: (item: any) => nil(item.stripePaymentObject) ? '' : this.priceDisplay(item.stripePaymentObject.amount / 100),
        },
    ];

    public get exportableOrders() {
        return this.selectedOrders.map((x) => ({
            _id: x._id,
            bookings: x.bookings,
            products: x.products,
            email: x.purchaserModel.email,
            phone: x.purchaserModel.phone,
            stripeSession: x.stripeSessionId,
            status: x.status,
            created: x.createdAt,
        }));
    }
    public onView(order) {
        this.$router.push(`/dashboard/orders/${order._id}`);
    }
    public onQuery() {
        return {
            ...this.addToQuery(),
        };
    }
    public get orderStatusConfig() {
        return orderStatusConfig;
    }
}
